import React, { useCallback, useState } from 'react'
import { ButtonBase, makeStyles, IconButton, Icon } from '@material-ui/core'
import { gray, purple } from '../../../utils/colors'

const useStyles = ({ showInfoButton, columns, disabled, selected }) =>
	makeStyles(() => {
		return {
			root: {
				display: 'flex',
				flexDirection: 'row',
				border: '0.125rem solid',
				borderColor: gray[500],
				borderRadius: '0.5625rem',
				maxWidth: '20rem',
				width: columns > 2 ? '17rem' : '19.375rem',
				minHeight: '5rem',
				padding: '.8rem 0 .8rem 0',
				paddingRight: showInfoButton ? 0 : '.8rem',
				opacity: disabled && !selected ? 0.5 : 1
			},
			infoButtonContainer: {
				paddingRight: '.8rem',
				width: '3rem',
				display: 'flex',
				justifyContent: 'center'
			},
			infoButton: {
				backgroundColor: purple[500],
				width: '1.1rem',
				height: '1.1rem',
				padding: '.6rem'
			},
			infoButtonIcon: {
				fontSize: '.625rem',
				color: 'white',
				overflow: 'unset'
			},
			rootSelected: {
				borderColor: purple[500],
				backgroundColor: purple[100]
			},
			rootDisabled: {},
			textContainer: {
				flex: 1,
				textAlign: 'left',
				display: 'flex',
				flexDirection: 'column',
				gap: '0.3rem',
				padding: '0 0.8rem'
			},
			idSquareContainer: { width: '3rem', display: 'flex', justifyContent: 'center', paddingLeft: '0.8rem' },
			idTextBoxContainer: {
				border: `0.1rem solid ${gray[700]}`,
				width: '1.5rem',
				height: '1.5rem',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: '0.125rem',
				fontFamily: 'Nunito',
				fontSize: '0.875rem'
			},
			idTextBoxContainerSelected: { color: purple[500], borderColor: purple[500] },
			title: { fontFamily: 'Nunito', fontSize: '0.875rem', fontWeight: '700', color: gray[900] },
			description: { fontFamily: 'Nunito', fontSize: '0.875rem', fontWeight: '600', color: gray[700] },
			imageContainer: {
				display: 'flex',
				paddingLeft: '0.8rem'
			},
			image: {
				width: '50px'
			}
		}
	})

const Option = ({
	title = '',
	description = '',
	icon = '',
	image = '',
	id = '',
	letter = '',
	selected = false,
	disabled = false,
	onSelected,
	onInfoButtonClicked,
	useTemporarySelectionVisualFeedback = false,
	columns = 1,
	style = {}
}) => {
	const classes = useStyles({ showInfoButton: onInfoButtonClicked !== undefined, columns, disabled, selected })()

	const [selectTemporarily, setSelectTemporarily] = useState(false)

	const handleOnSelected = useCallback(() => {
		if (onSelected) {
			onSelected()
		}
	}, [onSelected])

	const handleSelection = useCallback(() => {
		// Provides a brief moment of selected look to items that may not be visible after a popup closes.
		// Mainly used for Options that are in sub option dialogs
		if (!selected && useTemporarySelectionVisualFeedback) {
			setSelectTemporarily(true)
			setTimeout(() => {
				handleOnSelected()
				setSelectTemporarily(false)
			}, 200)
		} else {
			handleOnSelected()
		}
	}, [handleOnSelected, setSelectTemporarily, selected, useTemporarySelectionVisualFeedback])

	const handleOnInfoButtonClicked = useCallback(() => {
		if (onInfoButtonClicked) {
			onInfoButtonClicked()
		}
	}, [onInfoButtonClicked])

	return (
		<ButtonBase
			className={`${classes.root} ${(selected || selectTemporarily) && classes.rootSelected}`}
			style={style}
			disableRipple
			disabled={disabled}
			onClick={handleSelection}>
			{image > '' ? (
				<div className={classes.imageContainer}>
					<img src={image} className={classes.image} alt="option image" />
				</div>
			) : null}
			{letter > '' && !image ? (
				<div className={classes.idSquareContainer}>
					<div
						className={`${classes.idTextBoxContainer} ${
							(selected || selectTemporarily) && classes.idTextBoxContainerSelected
						}`}>
						{letter}
					</div>
				</div>
			) : null}
			{icon > '' ? <div style={{ width: '3rem' }}>{icon}</div> : null}
			<div className={classes.textContainer}>
				<div className={classes.title}>{title}</div>
				{description > '' ? <div className={classes.description}>{description}</div> : null}
			</div>
			{onInfoButtonClicked ? (
				<div className={classes.infoButtonContainer}>
					<IconButton
						className={classes.infoButton}
						onClick={(e) => {
							e.stopPropagation()
							handleOnInfoButtonClicked()
						}}>
						<Icon className={`fas fa-info ${classes.infoButtonIcon}`} />
					</IconButton>
				</div>
			) : null}
		</ButtonBase>
	)
}

export default Option
